export default __webpack_public_path__ + "static/media/cny-lucky-draw.04a1152c.webp";